<template>
  <div class="scences_re">
		<div class="scences_content">
			<div class="title">深入各类场景，</div>
			<div class="title">提供各行各业解决方案</div>
			<div class="tabs_wrap" ref="tabs_wrap">
				<div class="tabs_box">
					<div
						v-for="(item, index) in tabsList"
						:class="[`tabs_box_item`, index + 1 == currIdx ? 'active' : '']"
						@click="chooseTabs(index + 1)" :key="item"
					>
						{{ item }}
					</div>
					<div class="empty-20px">&nbsp;</div>
				</div>
			</div>
		</div>
		<div v-for="(item, index) in itemList" :class="['scences_bg',  `scences_bg_${item.key}`, index + 1 == currIdx ? 'active' : '' ]" :key="index">
			<div :class="['bg_icon_wrap', index + 1 === 6 ? 'special' : '']">
				<img :src="item.bgImg" alt="" draggable="false">
			</div>
			<div
				class="bg_content_wrap"
				v-touch:swipe.left="touchLeft"
				v-touch:swipe.right="touchRight"
			>
				<div class="content_img_wrap">
					<img :src="item.contentImg" alt="" draggable="false">
				</div>
				<div :class="['content_text_wrap',]">
					<p class="content_title">{{ item.title }}</p>
					<div :class="['content_box']">
						<div class="content_item" v-for="content in item.textList" :key="content">{{ content }}</div>
					</div>
				</div>
			</div>
		</div>
    <div class="btn_wrap">
      <router-link to="/enterprise" class="dl-btn">立即试用</router-link>
      <a v-if="currIdx === 1" class="dl-btn2" href="https://www.todesk.com/mobile/#/desktron">了解更多</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Scenes",
  data() {
    return {
			CLIENTWIDTH: null,
			currIdx: 1,
			tabsList: ['安全办公', '信创方案', '互动娱乐', '医疗健康', '运维管理', '高清设计', '技术支持'],
			itemList: [
				{
					key: 'security',
					title: '物理桌面+云桌面，一个系统统一管理',
					bgImg: 'https://todeskcdnspeed.todesk.com/202304191555365f9abbfcee5d04.png',
					contentImg: 'https://todeskcdnspeed.todesk.com/202305171208105fbdbd601c9484.png',
					textList: [
						'自研编解码器+RTC技术+SD-WAN网络技术，保障稳定流畅',
						'数据保存在远端，仅通过加密的远程访问协议在本地设备做视频流展示',
						'23项安全措施，事前数据不落地、事中过程可记录、事后行为可溯源'
					]
				},
				{
					key: 'itInnovation',
					title: '深耕信创 引领国产化',
					bgImg: 'https://todeskcdnspeed.todesk.com/2023091119433260513d5f216c1c.png',
					contentImg: 'https://todeskcdnspeed.todesk.com/20230911195825605140b381a34c.png',
					textList: [
						'全面支持统信UOS、银河麒麟、中科方德等操作系统',
						'全面兼容中国芯, 适配飞腾、鲲鹏、兆芯、海光、海思麒麟等国产CPU',
						'支持Windows与各大国产系统远程互联，稳定访问，安全流畅'
					]
				},
				{
					key: 'game',
					title: '畅享高玩体验，快乐无边界',
					bgImg: 'https://todeskcdnspeed.todesk.com/202304191430575f9aa911bfb6f4.png',
					contentImg: 'https://todeskcdnspeed.todesk.com/202305171208225fbdbd6ba5f1ac.png',
					textList: [
						'支持PS、Xbox游戏手柄',
						'最高支持4K60帧/2K144帧（主被控都需要在4.7.0.1版本以上）',
						'手机/电脑互控，自定义移动专属游戏键盘'
					]
				},
				{
					key: 'medical',
					title: '赋能数字医疗高质量发展',
					bgImg: 'https://todeskcdnspeed.todesk.com/2023091216495960525871e3de70.png',
					contentImg: 'https://todeskcdnspeed.todesk.com/202305181020395fbee735d019ac.png',
					textList: [
						'高清实时远程医疗会诊，流畅稳定',
						'自主掌控涉密数据和传输链路，确保连接安全合规',
						'医疗设备统一部署，器械故障快速排查'
					]
				},
				{
					key: 'upgrade',
					title: '设备快速升级、巡检、排障',
					bgImg: 'https://todeskcdnspeed.todesk.com/2023091217090960525cbaa555ec.png',
					contentImg: 'https://todeskcdnspeed.todesk.com/202305171208355fbdbd77f21190.png',
					textList: [
						'快速排查设备问题，减少故障造成的损失',
						'降低沟通成本，提升服务效率，顾客更满意',
						'企业级安全远程桌面，管理更省心'
					]
				},
				{
					key: 'highPerformance',
					title: '高性能远程桌面，满足专业设计需求',
					bgImg: 'https://todeskcdnspeed.todesk.com/202305151035095fbb24dac380e8.png',
					contentImg: 'https://todeskcdnspeed.todesk.com/202305181020265fbee728b8dbd4.png',
					textList: [
						'4K高清、60FPS流畅、40ms低延迟、4:4:4真色彩显示',
						'精准支持数位板操控，跨系统适配专业设计键鼠',
						'规范远程访问行为，确保公司数据不离开公司设备'
					]
				},
				{
					key: 'ease',
					title: '简单易用，一站式解决远程运维难题',
					bgImg: 'https://todeskcdnspeed.todesk.com/202304191432375f9aa970a1d29c.png',
					contentImg: 'https://todeskcdnspeed.todesk.com/202305171208515fbdbd877641f4.png',
					textList: [
						'SOS端支持绿色版免安装运行',
						'可为外部用户分配临时账号，保证安全',
						'全程操作云端录屏，高危操作支持多人核验'
					]
				}
			]
		}
  },
	watch: {
		currIdx(val) {
			if (val === 1) {
				this.$refs.tabs_wrap.scroll({
					left:  0,
					behavior: "smooth"
				})
				return
			}
			if (val === this.itemList.length) {
				this.$refs.tabs_wrap.scroll({
					left:  3 * this.CLIENTWIDTH,
					behavior: "smooth"
				})
				return
			}
			this.$refs.tabs_wrap.scroll({
				left: (val - 1) * 0.25 * this.CLIENTWIDTH,
				behavior: "smooth"
			})
		},
	},
  mounted() {
		this.CLIENTWIDTH = document.documentElement.clientWidth || 0
  },
  methods: {
    chooseTabs(index = 1) {
			this.currIdx = index
    },
		touchLeft() {
			if(this.currIdx == this.itemList.length){
        this.currIdx = 1;
      }else{
        this.currIdx ++
      }
		},
		touchRight() {
			if(this.currIdx == 1){
        this.currIdx = this.itemList.length;
      }else{
        this.currIdx --
      }
		}
  },
};
</script>

<style scoped lang="less">
.scences_re {
	width: 100%;
	height: 835px;
	position: relative;
	padding-top: 38px;
	box-sizing: border-box;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	.scences_content {
		z-index: 2;
		position: relative;
		.title {
			width: 100%;
			text-align: center;
			font-family: 'PingFang SC';
			font-weight: 600;
			font-size: 26px;
			line-height: 36px;
			letter-spacing: 0px;
			color: #000000;
		}
		.tabs_wrap {
			width: 375px;
			overflow-x: scroll;
			-webkit-overflow-scrolling: touch;
			margin-top: 30px;
			&::-webkit-scrollbar {
				display: none;
			}
		}
		.tabs_box {
			display: flex;
			align-items: center;
			user-select: none;
			width: auto;
			.tabs_box_item {
				width: 124px;
				box-sizing: border-box;
				padding: 9px 30px;
				flex-shrink: 0;
				font-family: PingFang SC;
				font-size: 16px;
				font-weight: 500;
				line-height: 22px;
				letter-spacing: 0px;
				color: rgba(116, 117, 118, 1);
				background-color: transparent;
				text-align: center;
				border-radius: 46px;
				white-space: nowrap;
				&:first-of-type {
					margin-left: 20px;
				}
				&.active {
					color: #fff;
					background-color: rgba(22, 22, 22, 1);
				}
			}
			.empty-20px {
				width: 0px;
				height: 39px;
				background-color: transparent;
				opacity: 0;
				margin-left: 15px;
			}
		}
	}
	.scences_bg {
		width: 100%;
		height: 100%;
		z-index: 0;
		opacity: 0;
		position: absolute;
		top: 0;
		&_security {
			background: linear-gradient(180deg, #FFF9F0 28.18%, #FFFFFF 100%);;
		}
		&_game {
			background: linear-gradient(180deg, #F6F1FF 28.18%, #FFFFFF 72.86%);;
		}
		&_medical {
			background: linear-gradient(180deg, #FFF9F0 28.18%, #FFFFFF 72.86%);;
		}
		&_upgrade {
			background: linear-gradient(180deg, #F1F3FF 28.18%, #FFFFFF 72.86%);
		}
		&_highPerformance {
			background: linear-gradient(180deg, #F1F3FF 28.18%, #FFFFFF 72.86%);
		}
		&_ease {
			background: linear-gradient(180deg, #F1F8FF 28.18%, #FFFFFF 72.86%);
		}
		&_itInnovation {
			background: linear-gradient(180deg, #F1F8FF 28.18%, #F2F8FF 72.86%);
		}
		&.active {
			z-index: 1;
			opacity: 1;
		}
		.bg_icon_wrap {
			width: 168px;
			height: auto;
			position: absolute;
			top: 16px;
			left: -40px;
			&.special {
				width: 148px;
			}
			img {
				user-select: none;
				width: 100%;
				height: auto;
				display: block;
			}
		}
		.bg_content_wrap {
			margin: 205px auto 0;
			overflow: hidden;
			touch-action: pan-y;
			.content_img_wrap {
				width: 335px;
				height: auto;
				margin: 0 auto;
				z-index: 1;
				border-radius: 13px;
				overflow: hidden;
				img {
					user-select: none;
					width: 335px;
					height: auto;
					display: block;
				}
			}
			.content_text_wrap {
				width: 335px;
				height: auto;
				box-sizing: border-box;
				margin: 20px auto 0;
				z-index: 0;
				.content_title {
					font-family: PingFang SC;
					font-size: 20px;
					font-weight: 500;
					line-height: 28px;
					letter-spacing: 0px;
					color: #000000;
				}
				.content_box {
					margin-top: 16px;
					.content_item {
						margin-bottom: 4px;
						padding-left: 12px;
						font-family: PingFang SC;
						font-size: 16px;
						font-weight: 400;
						line-height: 29px;
						letter-spacing: 0px;
						color: rgba(97, 99, 105, 1);
						text-align: left;
						position: relative;
						&:last-of-type {
							margin-bottom: 0;
						}
						&::before {
							content: '';
							position: absolute;
							width: 2px;
							height: 2px;
							background-color: rgba(97, 99, 105, 1);
							left: 0;
							top: 12px;
							border-radius: 50%;
						}
					}
				}
			}
		}
	}

  .btn_wrap{
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: center;
    padding-bottom: 30px;
    width: 375px;
    .dl-btn {
      z-index: 1;
      user-select: none;
      width: 159px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #0070F9;
      border-radius: 6px;
      font-family: 'PingFang SC';
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #FFFFFF;
      &:active {
        background-color: rgba(0,112,249,0.8);
      }
    }
    .dl-btn2{
      margin-left: 16px;
      width: 159px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #0070F9;
      border: 1px solid #0070F9;
      border-radius: 6px;
      font-size: 16px;
      &:hover{
        background: rgba(255, 255, 255, 0.15)
      }
    }
  }
}
</style>
